Handlebars.registerHelper('unlessEqual', function(a, b, options) {
    if(a !== b) {
        return options.fn(this);
    }
    return options.inverse(this);
});

Handlebars.registerHelper('toFixed', function(float, service) {
    if(float !== undefined) {
        return float.toFixed(2);
    }
    throw new Handlebars.Exception('Unknown field: float for service ' + service);
});

Handlebars.registerHelper('isEqual', function(val1, val2, options) {
    if(val1 === val2) {
        return options.fn(this);
    }
    return options.inverse(this);
});

Handlebars.registerHelper('toJSON', function(object) {
    return JSON.stringify(object).replace(/[\']/g, "\\u0027");
});

Handlebars.registerHelper('case', function(str, toCase) {
    if(str === undefined) {
        return '';
    }

    if(toCase === 'lower') {
        return str.toLowerCase();
    }

    if(toCase === 'upper') {
        return str.toUpperCase();
    }

    if(toCase === 'ucwords') {
        return str
            .toLowerCase()
            .split(' ').map(function(w) {
                return w.charAt(0).toUpperCase() + w.slice(1);
            })
            .join(' ');
    }

    throw new Handlebars.Exception('Unknown case: ' + toCase);
});

Handlebars.registerHelper('formatPostalCode', function(code, country) {
    country = country !== undefined ? country : 'US';

    if(country === 'US') {
        var matches = code.match(/^([0-9]{5})-?([0-9]{4})?$/i);
        matches && matches.shift();
        code = (matches || []).filter(function(match) {
            return !!match;
        }).join('-');
    } else if(country === 'CA') {
        var matches = code.match(/^([ABCEGHJKLMNPRSTVXY]{1}\d{1}[A-Z]{1})[ -]*?(\d{1}[A-Z]{1}\d{1})$/i);
        matches.shift();
        code = matches.join(' ');
    }

    return code;
});

// partials
Handlebars.registerPartial('address', Handlebars.templates['address_partial']);
Handlebars.registerPartial('actions', Handlebars.templates['actions_partial']);
